<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span>for</span></p>
<p class="ded1"><span><span class="smallcaps">HANNAH YAROWSKY</span> —</span></p>
<p class="ded1"><span>the youngest life of the party</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter.vue?05835476